import React, {useCallback, useEffect, useRef, useState} from "react";
import styles from "./UIGroupAudio.module.scss";
import mic from "./images/microphone.svg";
import actMic from "./images/active-microphone.svg";
import UIRecorder from "./audio/UIRecorder";
import {messageTypes,} from "./ChatConstants";

function create_UUID() {
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
    c
  ) {
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

const UIGroupAudio = (props: any) => {
  const [isRecord, setIsRecord]: any = useState(false);
  const [second, setSecond]: any = useState(0);
  const [minute, setMinute]: any = useState(0);
  const recordCTRLRef: any = useRef(null);
  const recorderRef: any = useRef(null);
  let timer: any;
  function blobToFile(theBlob: any, fileName: any) {
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  }
  const onStop = async (recordedBlob: any) => {
    if (document.getElementById("recordTime")?.innerHTML !== "00:00") {
      const timeMax = document.getElementById("recordTime")?.innerHTML;
      const recordTimestamp = new Date().getTime();
      var objFile = await blobToFile(
        recordedBlob?.blob,
        "chat-record-" + recordTimestamp + ".webm"
      );
      const tempMsgId = create_UUID();
      await props.pushLocalMessageFileMedia(
        messageTypes.Sound,
        {
          objFile: objFile,
          blob: recordedBlob?.blob,
          blobURL: recordedBlob?.blobURL,
          timeRecord: timeMax,
        },
        tempMsgId,
        "",
        null
      );
      props.setOpenRecordAudio(false);
    }
  };

  const startTimer = async () => {
    setSecond(0);
    setMinute(0);
    if (timer) clearInterval(timer);
    timer = setInterval(() => {
      setSecond((prevState: number) => prevState + 1);
    }, 1000);
  };

  useEffect(() => {
    if (minute < 3 && second > 59) {
      setSecond(0);
      setMinute((prevState: number) => prevState + 1);
    }
    if (minute === 3 && second === 0) {
      setSecond(0);
      setMinute(3);
      recorderRef.current.stopRecord();
      setIsRecord(false);
    }
  }, [second, minute]);

  useEffect(() => {
    if (isRecord) {
      startTimer();
    }
    return () => {
      clearInterval(timer);
    };
  }, [isRecord]);


  var checkRecord = false;
  const handleRecord = useCallback((event) => {

    if (event.type === "mousedown") {
      if (!checkRecord) {
        console.log("ON");
        setIsRecord(true);
        recorderRef.current.startRecord();
      }else {
        console.log("STOP");
        setIsRecord(false);
        recorderRef.current.stopRecord();
      }
      checkRecord = !checkRecord; 
    }
    // if (event.type === "mouseup" || event.type === "mouseleave") {
    //   setIsRecord(false);
    //   recorderRef.current.stopRecord();
    // }
  }, []);

  useEffect(() => {
    // when mounted
    recordCTRLRef.current.addEventListener("mousedown", handleRecord);
    // recordCTRLRef.current.addEventListener("mouseup", handleRecord);
    return () => {
      //remove event when will unmount
      recordCTRLRef.current.removeEventListener("mousedown", handleRecord);
      // recordCTRLRef.current.removeEventListener("mouseup", handleRecord);
    };
  }, [recordCTRLRef.current, handleRecord]);

  return (
    <>
      <div
        className={styles.uiGroupAudio}
        style={
          props.isOpenRecordAudio
            ? {
                display: "block",
                // borderTop: " 1px solid #e6e6e6",
                backgroundColor: "#F9F9F9",
                height: "130px",
                width: "200px"
              }
            : { display: "none" }
        }
      >
        <div className={styles.reactMic}>
          {/* {isRecord && ( */}
          <div
            className={styles.boxRecordTime}
            style={isRecord ? { display: "block" } : { display: "none" }}
          >
            <div className={styles.boxRecordTimeIn}>
              <span id="recordTime">
                {minute < 10 ? "0" + minute : minute}:
                {second < 10 ? "0" + second : second}
              </span>
            </div>
            <div className={styles.boxRecordTimeArrowDown}></div>
          </div>
          {/* )} */}
          <div className={styles.divCanvas}>
            <UIRecorder
              ref={recorderRef}
              //@ts-ignore
              className={styles.soundWave}
              mimeType={"audio/mp4"}
              visualSetting="sinewave" // defaults -> "sinewave".  Other option is "frequencyBars"
              onStop={onStop}
              strokeColor="#0F4C82"
              backgroundColor="#F9F9F9"
              echoCancellation={true} // defaults -> false
              autoGainControl={true} // defaults -> false
              noiseSuppression={true} // defaults -> false
              channelCount={2} // defaults -> 2 (stereo).  Specify 1 for mono.
              bitRate={256000} // defaults -> 128000 (128kbps).  React-Mic-Gold only.
            />
          </div>
        </div>
        <div className={styles.boxBtnRecord}>
          <div className={styles.boxBtnRecordIn}>
            {/* <Button> */}
              <div
                id="box-btn-record-cricle"
                className={styles.boxBtnRecordCricle}
                onContextMenu={(e) => e.preventDefault()}
                ref={recordCTRLRef}
              >
                <div className={styles.divImg}>
                  <img
                    alt="preload"
                    src={!isRecord ? mic : actMic}
                    width="14px"
                    height="20px"
                  />
                </div>
              </div>
            {/* </Button> */}
          </div>
          {/* <ons-toolbar-button onClick={() => { setIsRecord(false); }} type="button">Stop</ons-toolbar-button> */}
        </div>
      </div>
    </>
  );
};

export default React.memo(UIGroupAudio);
